import type { LibraryBlock } from "../build";
import {
  BLACK_GLASS,
  CARD_SHADOW,
  ellipse,
  icon,
  iconPill,
  motion,
  photo,
  pill,
  rect,
  SHADOW,
  text,
  WHITE,
} from "./helpers";

// ---------------------------------------------------------------------------
// Social: subscribe, like, comments, profile, polls
// ---------------------------------------------------------------------------

/** Abonnieren → Abonniert: the switch happens here (ms after the block's start). */
const CLICK = 1900;

export const SOCIAL: LibraryBlock[] = [
  {
    id: "social-abonnieren",
    title: "Abonnieren mit Glocke",
    category: "social",
    tags: ["Abo", "Subscribe", "Glocke", "YouTube", "Klick"],
    width: 720,
    height: 260,
    anchor: "bottom",
    duration: 4500,
    only: "video",
    nodes: [
      rect({
        x: 0,
        y: 40,
        w: 560,
        h: 130,
        fill: "primary",
        radius: "full",
        shadow: CARD_SHADOW,
        name: "Knopf",
        ...motion("pop", { until: CLICK, out: null }),
      }),
      text({
        text: "ABONNIEREN",
        style: "heading-2",
        size: 50,
        color: "on:primary",
        x: 40,
        y: 40,
        w: 480,
        h: 130,
        align: "center",
        ...motion("pop", { until: CLICK, out: null }),
      }),
      rect({
        x: 0,
        y: 40,
        w: 560,
        h: 130,
        fill: "surface",
        radius: "full",
        shadow: CARD_SHADOW,
        name: "Knopf abonniert",
        ...motion("fade", { delay: CLICK, duration: 150 }),
      }),
      text({
        text: "ABONNIERT",
        style: "heading-2",
        size: 50,
        color: "text-muted",
        x: 40,
        y: 40,
        w: 480,
        h: 130,
        align: "center",
        ...motion("fade", { delay: CLICK, duration: 150 }),
      }),
      ellipse({
        x: 590,
        y: 40,
        w: 130,
        h: 130,
        fill: "background",
        shadow: CARD_SHADOW,
        name: "Kreis",
        ...motion("pop", { delay: 200 }),
      }),
      icon({
        icon: "bell",
        x: 620,
        y: 70,
        w: 70,
        h: 70,
        color: "text",
        name: "Glocke",
        ...motion("pop", { delay: 200, until: CLICK + 200, out: null }),
      }),
      icon({
        icon: "bell-ringing",
        x: 620,
        y: 70,
        w: 70,
        h: 70,
        color: "primary",
        name: "Glocke klingelt",
        ...motion("pop", { delay: CLICK + 200, duration: 300, loop: "wiggle" }),
      }),
      icon({
        icon: "hand-pointing",
        x: 240,
        y: 120,
        w: 130,
        h: 130,
        color: WHITE,
        shadow: SHADOW,
        name: "Zeiger",
        ...motion("fly-up", { delay: 900, duration: 700 }),
      }),
    ],
  },
  {
    id: "social-like",
    title: "Like-Herz",
    category: "social",
    tags: ["Herz", "Gefällt mir", "Like", "Liebe"],
    width: 360,
    height: 380,
    anchor: "bottom-right",
    duration: 3500,
    nodes: [
      ellipse({
        x: 30,
        y: 0,
        w: 300,
        h: 300,
        fill: "background",
        shadow: CARD_SHADOW,
        name: "Kreis",
        ...motion("pop"),
      }),
      icon({
        icon: "heart",
        x: 90,
        y: 64,
        w: 180,
        h: 180,
        color: "#f43f5e",
        name: "Herz",
        ...motion("pop", { delay: 150, duration: 600, loop: "pulse" }),
      }),
      ...pill(30, 310, 300, 70, "Gefällt mir", "primary", 28, motion("slide-up", { delay: 350 })),
    ],
  },
  {
    id: "social-kommentar",
    title: "Antwort auf Kommentar",
    category: "social",
    tags: ["Kommentar", "Frage", "Reply", "TikTok", "Community"],
    width: 860,
    height: 250,
    anchor: "top",
    duration: 5000,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 860,
        h: 250,
        fill: "background",
        radius: "lg",
        shadow: CARD_SHADOW,
        name: "Karte",
        ...motion("slide-down"),
      }),
      photo({
        x: 36,
        y: 36,
        w: 90,
        h: 90,
        ellipse: true,
        name: "Profilbild",
        ...motion("zoom", { delay: 150 }),
      }),
      text({
        text: "Antwort auf @lena.backt",
        style: "caption",
        size: 28,
        color: "text-muted",
        x: 150,
        y: 40,
        w: 670,
        ...motion("fade", { delay: 200 }),
      }),
      text({
        text: "Wie lange muss der Teig ruhen?",
        style: "heading-2",
        size: 50,
        color: "text",
        x: 150,
        y: 86,
        w: 670,
        ...motion("slide-up", { delay: 300 }),
      }),
    ],
  },
  {
    id: "social-profil",
    title: "Profil-Karte",
    category: "social",
    tags: ["Profil", "Follower", "Folgen", "Creator", "Account"],
    width: 820,
    height: 300,
    anchor: "center",
    duration: 5000,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 820,
        h: 300,
        fill: "background",
        radius: "lg",
        shadow: CARD_SHADOW,
        name: "Karte",
        ...motion("pop"),
      }),
      photo({
        x: 40,
        y: 50,
        w: 200,
        h: 200,
        ellipse: true,
        name: "Profilbild",
        ...motion("zoom", { delay: 150 }),
      }),
      text({
        text: "Maxi Mustermann",
        style: "heading-2",
        size: 50,
        color: "text",
        x: 280,
        y: 50,
        w: 500,
        ...motion("slide-left", { delay: 250 }),
      }),
      text({
        text: "@deinkanal · 12,5 Tsd. Follower",
        style: "caption",
        size: 28,
        color: "text-muted",
        x: 280,
        y: 118,
        w: 500,
        ...motion("slide-left", { delay: 330 }),
      }),
      ...pill(
        280,
        180,
        240,
        72,
        "Folgen",
        "primary",
        30,
        motion("pop", { delay: 500, loop: "pulse" }),
      ),
    ],
  },
  {
    id: "social-hashtag",
    title: "Hashtag",
    category: "social",
    tags: ["#", "Tag", "Trend", "Schlagwort"],
    width: 640,
    height: 120,
    anchor: "center",
    duration: 3500,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 640,
        h: 120,
        fill: "background",
        radius: "full",
        shadow: CARD_SHADOW,
        name: "Pille",
        ...motion("slide-right"),
      }),
      ellipse({
        x: 10,
        y: 10,
        w: 100,
        h: 100,
        fill: "accent",
        name: "Kreis",
        ...motion("spin", { delay: 150 }),
      }),
      text({
        text: "#",
        style: "heading-1",
        size: 64,
        color: "on:accent",
        x: 10,
        y: 10,
        w: 100,
        h: 100,
        align: "center",
        ...motion("spin", { delay: 150 }),
      }),
      text({
        text: "sommerrezepte",
        style: "heading-2",
        size: 48,
        color: "text",
        x: 134,
        y: 0,
        w: 470,
        h: 120,
        ...motion("slide-right", { delay: 250 }),
      }),
    ],
  },
  {
    id: "social-umfrage",
    title: "Umfrage",
    category: "social",
    tags: ["Abstimmung", "Poll", "Voting", "Frage", "Prozent"],
    width: 880,
    height: 440,
    anchor: "center",
    duration: 5500,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 880,
        h: 440,
        fill: "background",
        radius: "lg",
        shadow: CARD_SHADOW,
        name: "Karte",
        ...motion("pop"),
      }),
      text({
        text: "Kaffee oder Tee?",
        style: "heading-2",
        size: 56,
        color: "text",
        x: 50,
        y: 40,
        w: 780,
        align: "center",
        ...motion("fade", { delay: 150 }),
      }),
      ...[
        { label: "Kaffee", value: "64 %", share: 0.64, y: 150 },
        { label: "Tee", value: "36 %", share: 0.36, y: 286 },
      ].flatMap((option, index) => {
        const delay = 400 + index * 250;
        return [
          rect({
            x: 50,
            y: option.y,
            w: 780,
            h: 110,
            fill: "surface",
            radius: "md",
            name: "Option",
            ...motion("fade", { delay: 250 }),
          }),
          rect({
            x: 50,
            y: option.y,
            w: 780 * option.share,
            h: 110,
            fill: index === 0 ? "primary/35" : "primary/15",
            radius: "md",
            name: "Anteil",
            ...motion("slide-right", { delay, duration: 700 }),
          }),
          text({
            text: option.label,
            style: "subline",
            size: 38,
            color: "text",
            x: 84,
            y: option.y,
            w: 460,
            h: 110,
            ...motion("fade", { delay: 250 }),
          }),
          text({
            text: option.value,
            style: "heading-2",
            size: 40,
            color: "text",
            x: 580,
            y: option.y,
            w: 220,
            h: 110,
            align: "right",
            ...motion("fade", { delay: delay + 500 }),
          }),
        ];
      }),
    ],
  },
  {
    id: "social-teilen",
    title: "Teilen",
    category: "social",
    tags: ["Share", "weiterleiten", "schicken", "Freunde"],
    width: 760,
    height: 120,
    anchor: "bottom",
    duration: 4000,
    nodes: iconPill(0, 0, 760, 120, {
      icon: "paper-plane-tilt",
      label: "Schick das jemandem!",
      fill: "primary",
      badge: "background",
      iconColor: "primary",
      size: 42,
      move: motion("slide-up"),
      iconMove: motion("pop", { delay: 250, loop: "float" }),
    }),
  },
  {
    id: "social-frage-sticker",
    title: "Frage-Sticker",
    category: "social",
    tags: ["Frage", "Story", "Q&A", "Fragerunde", "Instagram"],
    width: 760,
    height: 330,
    anchor: "center",
    duration: 4500,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 760,
        h: 330,
        fill: "background",
        radius: "lg",
        shadow: CARD_SHADOW,
        name: "Karte",
        ...motion("pop"),
      }),
      rect({
        x: 0,
        y: 0,
        w: 760,
        h: 110,
        fill: "primary",
        radius: "lg",
        name: "Kopf",
        ...motion("pop"),
      }),
      rect({ x: 0, y: 60, w: 760, h: 50, fill: "primary", name: "Kopf", ...motion("pop") }),
      text({
        text: "Stell mir eine Frage",
        style: "heading-2",
        size: 44,
        color: "on:primary",
        x: 40,
        y: 0,
        w: 680,
        h: 110,
        align: "center",
        ...motion("pop"),
      }),
      rect({
        x: 40,
        y: 150,
        w: 680,
        h: 130,
        fill: "surface",
        radius: "md",
        name: "Eingabe",
        ...motion("fade", { delay: 250 }),
      }),
      text({
        text: "Hier tippen …",
        style: "body",
        size: 36,
        color: "text-muted",
        x: 70,
        y: 150,
        w: 620,
        h: 130,
        align: "center",
        ...motion("typewriter", { delay: 450, duration: 800 }),
      }),
    ],
  },
  {
    id: "social-push",
    title: "Push-Nachricht",
    category: "social",
    tags: ["Benachrichtigung", "Notification", "Handy", "neu online"],
    width: 960,
    height: 190,
    anchor: "top",
    duration: 4000,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 960,
        h: 190,
        fill: "background/95",
        radius: "lg",
        shadow: CARD_SHADOW,
        name: "Nachricht",
        ...motion("fly-down", { duration: 600, out: "fly-up" }),
      }),
      rect({
        x: 30,
        y: 40,
        w: 110,
        h: 110,
        fill: "primary",
        radius: "md",
        name: "App-Symbol",
        ...motion("fly-down", { duration: 600, out: "fly-up" }),
      }),
      icon({
        icon: "bell",
        x: 55,
        y: 65,
        w: 60,
        h: 60,
        color: "on:primary",
        name: "Glocke",
        ...motion("fly-down", { duration: 600, out: "fly-up", loop: "wiggle" }),
      }),
      text({
        text: "Deine Marke · jetzt",
        style: "caption",
        size: 24,
        color: "text-muted",
        x: 170,
        y: 36,
        w: 740,
        ...motion("fly-down", { duration: 600, out: "fly-up" }),
      }),
      text({
        text: "Neues Video ist online!",
        style: "heading-2",
        size: 44,
        color: "text",
        x: 170,
        y: 72,
        w: 740,
        ...motion("fly-down", { duration: 600, out: "fly-up" }),
      }),
      text({
        text: "Jetzt reinschauen und mitreden.",
        style: "body",
        size: 30,
        color: "text-muted",
        x: 170,
        y: 132,
        w: 740,
        ...motion("fly-down", { duration: 600, out: "fly-up" }),
      }),
    ],
  },
  {
    id: "social-live",
    title: "Live mit Zuschauern",
    category: "social",
    tags: ["Live", "Stream", "Zuschauer", "Viewer"],
    width: 460,
    height: 84,
    anchor: "top-left",
    duration: 5000,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 180,
        h: 84,
        fill: "#dc2626",
        radius: "sm",
        name: "Live",
        ...motion("pop"),
      }),
      text({
        text: "LIVE",
        style: "heading-2",
        size: 40,
        color: WHITE,
        x: 0,
        y: 0,
        w: 180,
        h: 84,
        align: "center",
        ...motion("pop"),
      }),
      rect({
        x: 190,
        y: 0,
        w: 270,
        h: 84,
        fill: BLACK_GLASS,
        radius: "sm",
        name: "Zuschauer",
        ...motion("slide-right", { delay: 150 }),
      }),
      icon({
        icon: "eye",
        x: 210,
        y: 19,
        w: 46,
        h: 46,
        color: WHITE,
        name: "Auge",
        ...motion("slide-right", { delay: 150 }),
      }),
      text({
        text: "1,2 Tsd.",
        style: "subline",
        size: 34,
        color: WHITE,
        x: 270,
        y: 0,
        w: 170,
        h: 84,
        ...motion("slide-right", { delay: 200 }),
      }),
    ],
  },
];
